import Vue from 'vue'
import App from './App'
import router from './router'
import 'mint-ui/lib/style.css'
import MintUI from 'mint-ui'
import './assets/css/style.css'
import { http } from './http/api'
import store from './store'
import _ from 'lodash'
import './utils/rem'

Vue.use(MintUI)
Vue.prototype.$http = http
Vue.config.productionTip = false
Vue.prototype._ = _

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js